// Compute the box-shadow string for an element's highlight (glow) effect.
// Returns null when no glow should be rendered.
//
// In the editor pass `alwaysShow: true` to preview the glow regardless of
// the mode the user picked. In the lesson runtime pass `runtimeOn` from the
// synced highlight state — for `mode: 'always'` the glow renders unconditionally.
export const getHighlightBoxShadow = (element, { runtimeOn = false, alwaysShow = false } = {}) => {
  const hl = element?.style?.highlight;
  if (!hl?.enabled) return null;

  const color = hl.color || '#FACC15';
  const mode = hl.mode || 'always';

  const isOn = alwaysShow || mode === 'always' || !!runtimeOn;
  if (!isOn) return null;

  return `0 0 30px 8px ${color}, 0 0 14px 4px ${color}`;
};

// True when the element is highlight-enabled and reacts to clicks during a lesson.
export const isHighlightClickable = (element) => {
  const hl = element?.style?.highlight;
  if (!hl?.enabled) return false;
  return hl.mode === 'click-toggle' || hl.mode === 'click-once';
};
